import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './InputTable.scss';
import { useParams } from 'react-router-dom';
import ErrorModal from '../ErrorModal/ErrorModal';
import { toast } from 'react-toastify';
import InputField from '../form/FormInput';
import { deactivateBatchApi, reactivateBatchApi } from '../../services/products';
import { RiDeleteBinLine } from 'react-icons/ri';
import { BsToggleOn, BsToggleOff } from 'react-icons/bs';
import BatchConfirmModal from '../modal/BatchConfirmModal';

const InputTable = ({
	initialRows = [],
	columns = [],
	className = '',
	onChange,
	value = [],
	disabled = false,
	newRowgenerate = '',
	productTabelError,
	setIsTableError,
	setErrorCells,
	errorCells,
	Tabletype = '',
	productName = '',
}) => {
	const param = useParams();
	const productID = param?.id;
	const [rows, setRows] = useState([]);
	const inputRefs = useRef([]);
	const [showError, setShowError] = useState(false);
	const date = new Date();
	const ThisYear = date.getFullYear().toString().slice(-2);
	const Thismonth = (date.getMonth() + 1).toString().padStart(2, '0');

	const [confirmModal, setConfirmModal] = useState({
		isOpen: false,
		batchId: '',
		batchNo: '',
		statusLabel: '',
		statusColor: '',
		actionType: 'deactivate',
		reason: 'Batch has expired',
		customReason: '',
		rowIndex: null,
		loader: false,
	});

	const getBatchStatus = (row) => {
		const isDeactivated =
			row.is_active === false || row.is_active === 0 || row.is_active === '0';

		if (isDeactivated) {
			return {
				label: 'Disabled',
				color: '#64748B',
				statusType: 'disabled',
				isDeactivated: true,
				canToggle: true,
			};
		}

		let isExpired = false;
		if (row.expiry_date) {
			const clean = String(row.expiry_date).replace(/\D/g, '');
			if (clean.length >= 4) {
				const expMonth = parseInt(clean.slice(0, 2), 10);
				const expYear = parseInt('20' + clean.slice(2, 4), 10);
				const now = new Date();
				const curYear = now.getFullYear();
				const curMonth = now.getMonth() + 1;
				if (expYear < curYear || (expYear === curYear && expMonth < curMonth)) {
					isExpired = true;
				}
			}
		}

		const qty = parseFloat(row.quantity || 0) + parseFloat(row.free_quantity || 0);

		if (isExpired) {
			return {
				label: 'Expired',
				color: '#DC2626',
				statusType: 'expired',
				isDeactivated: false,
				canToggle: true,
			};
		}

		if (qty <= 0) {
			return {
				label: 'Out of Stock',
				color: '#D97706',
				statusType: 'out_of_stock',
				isDeactivated: false,
				canToggle: true,
			};
		}

		return {
			label: 'Active',
			color: '#16A34A',
			statusType: 'active',
			isDeactivated: false,
			canToggle: true,
		};
	};

	const handleToggleClick = (row, index, status) => {
		const isCurrentlyActive =
			row.is_active !== false && row.is_active !== 0 && row.is_active !== '0';
		const actionType = isCurrentlyActive ? 'deactivate' : 'reactivate';
		let defaultReason = 'Batch has expired';
		if (actionType === 'reactivate') {
			defaultReason = 'Stock replenished / restocked';
		} else if (status.statusType === 'out_of_stock') {
			defaultReason = 'Batch is out of stock';
		} else if (status.statusType === 'expired') {
			defaultReason = 'Batch has expired';
		} else {
			defaultReason = 'Discontinued product/batch';
		}

		setConfirmModal({
			isOpen: true,
			batchId: row.product_batch_id,
			batchNo: row.batch_no || 'N/A',
			statusLabel: status.label,
			statusColor: status.color,
			actionType,
			reason: defaultReason,
			customReason: '',
			rowIndex: index,
			loader: false,
		});
	};

	const handleConfirmModal = async () => {
		const { batchId, actionType, reason, customReason, rowIndex } = confirmModal;
		const isOther = reason === 'Other';
		const finalReason = isOther ? (customReason?.trim() || '') : (reason || '');

		if (isOther && !finalReason) {
			toast.warn('Please specify a reason');
			return;
		}

		setConfirmModal((prev) => ({ ...prev, loader: true }));

		try {
			if (actionType === 'deactivate') {
				await deactivateBatchApi(batchId, {
					reason: finalReason || 'Batch disabled from product details',
				});
				toast.success('Batch disabled successfully');
			} else {
				await reactivateBatchApi(batchId, {
					reason: finalReason || 'Batch reactivated from product details',
				});
				toast.success('Batch reactivated successfully');
			}

			const updatedRows = rows.map((r, i) => {
				if (i === rowIndex || r.product_batch_id === batchId) {
					return {
						...r,
						is_active: actionType === 'reactivate',
					};
				}
				return r;
			});
			setRows(updatedRows);
			if (onChange) {
				onChange(updatedRows);
			}
			setConfirmModal((prev) => ({ ...prev, isOpen: false, loader: false }));
		} catch (error) {
			setConfirmModal((prev) => ({ ...prev, loader: false }));
			const msg = error?.response?.data?.message || error?.message || 'Action failed';
			toast.error(msg);
		}
	};

	// 		const errors = columns
	// 			.filter((col) => {
	// 				const value = LastRow[col.name];
	// 				const placeholderCheckFields = [
	// 					'quantity',
	// 					'mrp',
	// 					'purchase_rate',
	// 					'batch_no',
	// 					'mfg_date',
	// 					'expiry_date',
	// 				];

	// 				if (placeholderCheckFields.includes(col.name)) {
	// 					return value === null || value === '' || value === 'MM/YY' || value === '0.00';
	// 				} else if (simpleCheckFields.includes(col.name)) {
	// 					return value === null || value === '';
	// 				}

	// 				return false;
	// 			})
	// 			.map((col) => ({
	// 				index: LastRowIndex,
	// 				field: col.name,
	// 			}));
	// 		const purchaseRate = Number(LastRow?.purchase_rate);
	// 		const mrp = Number(LastRow?.mrp);
	// 		const saleRate = Number(LastRow?.sale_rate);

	// 		if (Number(saleRate) > 0 && (saleRate < purchaseRate || saleRate > mrp)) {
	// 			errors.push({
	// 				index: LastRowIndex,
	// 				field: 'sale_rate',
	// 			});
	// 		}
	// 		setErrorCells((prevErrorCells) => [
	// 			...prevErrorCells.filter((error) => !(error.index === LastRowIndex)),
	// 			...errors,
	// 		]);
	// 	}
	// }, [productTabelError]);
	useEffect(() => {
		if (productTabelError && rows?.length > 0 && errorCells.length > 0) {
			const LastRowIndex = rows.length - 1;
			const LastRow = rows[LastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = LastRow[col.name];

					const placeholderCheckFields = [
						'mrp',
						'batch_no',
					];

					const simpleCheckFields = ['trade_rate', 'sale_rate', 'quantity'];

					if (placeholderCheckFields.includes(col.name)) {
						return value === null || value === '' || value === 'MM/YY' || value === '0.00';
					} else if (simpleCheckFields.includes(col.name)) {
						return value === null || value === '';
					}

					return false;
				})
				.map((col) => ({
					index: LastRowIndex,
					field: col.name,
				}));

			const purchaseRate = Number(LastRow?.purchase_rate);
			const mrp = Number(LastRow?.mrp);
			const saleRate = Number(LastRow?.sale_rate);

			// ✅ Purchase Rate vs MRP validation
			if (purchaseRate > 0 && mrp > 0 && purchaseRate > mrp) {
				errors.push(
					{ index: LastRowIndex, field: 'purchase_rate' },
					{ index: LastRowIndex, field: 'mrp' },
				);
			}

			// ✅ Sale Rate validation
			if (saleRate > 0 && (saleRate < purchaseRate || saleRate > mrp)) {
				errors.push({ index: LastRowIndex, field: 'sale_rate' });
			}

			// 🔁 Replace only last row errors
			setErrorCells((prevErrorCells) => [
				...prevErrorCells.filter((error) => error.index !== LastRowIndex),
				...errors,
			]);
		}
	}, [productTabelError]);

	const addRow = () => {
		const emptyRow = columns.reduce((acc, col) => {
			switch (col.name) {
				case 'batch_no':
					acc[col.name] = null;
					break;
				case 'quantity':
				case 'free_quantity':
					acc[col.name] = '';
					break;
				case 'mfg_date':
				case 'expiry_date':
					acc[col.name] = '';
					break;
				case 'mrp':
				case 'trade_rate':
				case 'purchase_rate':
				case 'sale_rate':
					acc[col.name] = '';
					break;
				case 'product_batch_id':
					acc[col.name] = '';
					break;
				default:
					acc[col.name] = '';
			}
			return acc;
		}, {});

		const newRows = [...rows, emptyRow];
		setRows(newRows);

		if (newRows.length > 1) {
			const secondLastRowIndex = newRows.length - 2;
			const secondLastRow = newRows[secondLastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];
					const placeholderCheckFields = [
						'mrp',
						'batch_no',
					];

					const simpleCheckFields = ['trade_rate', 'sale_rate', 'quantity'];

					if (placeholderCheckFields.includes(col.name)) {
						return value === null || value === '' || value === 'MM/YY' || value === '0.00';
					} else if (simpleCheckFields.includes(col.name)) {
						return value === 0;
					}

					return false;
				})
				.map((col) => ({
					index: secondLastRowIndex,
					field: col.name,
				}));
			const purchaseRate = Number(secondLastRow?.purchase_rate);
			const mrp = Number(secondLastRow?.mrp);
			const saleRate = Number(secondLastRow?.sale_rate);
			if (Number(saleRate || 0) > 0 && (saleRate < purchaseRate || saleRate > mrp)) {
				errors.push({
					index: secondLastRowIndex,
					field: 'sale_rate',
				});
			}
			if (purchaseRate > 0 && mrp > 0 && purchaseRate > mrp) {
				errors.push({ index: secondLastRowIndex, field: 'purchase_rate' });
			}

			setErrorCells((prevError) => [
				...prevError.filter(
					(er) =>
						!(
							er.index === secondLastRowIndex &&
							(er.customErrorMessage === null || er.customErrorMessage === undefined)
						),
				),
				...errors,
			]);
		}
		if (onChange) {
			onChange(newRows);
		}
		setTimeout(() => {
			inputRefs.current[newRows.length - 1]?.[0]?.focus();
		}, 0);
	};

	const deleteLastRow = (index) => {
		deleteRow(index);
	};

	const deleteRow = (index) => {
		try {
			if (rows.length > 1) {
				const newRows = [...rows];
				newRows.splice(index, 1);
				const newInputRefs = [...inputRefs.current];
				newInputRefs.splice(index, 1);
				inputRefs.current = newInputRefs;

				// Step 1: Remove old errors and re-index them
				let newErrorCells = errorCells
					.filter((error) => error.index !== index)
					.map((error) => ({
						...error,
						index: error.index > index ? error.index - 1 : error.index,
					}));

				// Step 2: Remove all batch_no errors (we will recalculate)
				newErrorCells = newErrorCells.filter((error) => error.field !== 'batch_no');

				// Step 3: Recalculate duplicate batch errors
				const batchCount = {};
				newRows.forEach((row) => {
					if (row.batch_no) {
						batchCount[row.batch_no] = (batchCount[row.batch_no] || 0) + 1;
					}
				});

				newRows.forEach((row, i) => {
					if (row.batch_no && batchCount[row.batch_no] > 1) {
						newErrorCells.push({
							index: i,
							field: 'batch_no',
							customErrorMessage: {
								batch_no: 'This batch number already exists in the product table.',
							},
						});
					}
				});
				setRows(newRows);
				setErrorCells(newErrorCells);
				if (onChange) {
					onChange(newRows);
				}
				setTimeout(() => {
					if (newRows.length > 0) {
						inputRefs.current[newRows.length - 1]?.[0]?.focus();
					}
				}, 0);
			} else {
				const newRows = [...rows];
				newRows.splice(index, 2);
				setRows(newRows);
				if (onChange) {
					onChange(newRows);
				}
				setErrorCells([]);
			}
		} catch (e) {
			toast.error(e.response.message);
		}
	};

	useEffect(() => {
		setRows(value.length > 0 ? value : initialRows.length > 0 ? initialRows : []);
	}, [value, initialRows]);

	const handleDateChange = (index, value, field) => {
		value = value.replace(/\D/g, '');

		if (value.length > 4) {
			value = value.slice(0, 4);
		}

		if (value.length >= 2) {
			let month = value.slice(0, 2);
			const year = value.slice(2);

			if (month > '12') {
				month = '12';
			}
			if (value.length === 2) {
				value = `${month}`;
			} else {
				value = `${month}/${year}`;
			}
		}
		const isValidDateStr = (dateStr) =>
			typeof dateStr === 'string' &&
			dateStr !== 'MM/YY' &&
			dateStr !== '' &&
			dateStr.length === 5 &&
			dateStr.includes('/');

		if (field === 'expiry_date') {
			let currentRow = rows[index];
			let currentRowmfg_date = currentRow?.mfg_date;
			if (isValidDateStr(value) && isValidDateStr(currentRowmfg_date)) {
				const mfgParts = currentRowmfg_date.split('/');
				const expParts = value.split('/');
				const mfgYear = Number(mfgParts[1]);
				const mfgMonth = Number(mfgParts[0]);
				const expYear = Number(expParts[1]);
				const expMonth = Number(expParts[0]);

				if (mfgYear > expYear || (mfgYear === expYear && mfgMonth > expMonth)) {
					addErrorCell(index, 'expiry_date');
				} else {
					removeErrorCell(index, 'expiry_date');
				}
			} else {
				removeErrorCell(index, 'expiry_date');
			}
		}
		if (field === 'mfg_date') {
			let currentRow = rows[index];
			let currentRowExpDate = currentRow?.expiry_date;

			if (isValidDateStr(value)) {
				const mfgParts = value.split('/');
				const mfgYear = Number(mfgParts[1]);
				const mfgMonth = Number(mfgParts[0]);

				if (mfgYear > ThisYear || (mfgYear === ThisYear && mfgMonth > Thismonth)) {
					addErrorCell(index, 'mfg_date');
				} else {
					removeErrorCell(index, 'mfg_date');
				}
			} else {
				removeErrorCell(index, 'mfg_date');
			}

			if (isValidDateStr(value) && isValidDateStr(currentRowExpDate)) {
				const mfgParts = value.split('/');
				const expParts = currentRowExpDate.split('/');
				const mfgYear = Number(mfgParts[1]);
				const mfgMonth = Number(mfgParts[0]);
				const expYear = Number(expParts[1]);
				const expMonth = Number(expParts[0]);

				if (mfgYear > expYear || (mfgYear === expYear && mfgMonth > expMonth)) {
					addErrorCell(index, 'expiry_date');
				} else {
					removeErrorCell(index, 'expiry_date');
				}
			} else {
				removeErrorCell(index, 'expiry_date');
			}
		}

		const newRows = [...rows];
		newRows[index][field] = value;
		setRows(newRows);
		if (onChange) {
			onChange(newRows);
		}
	};

	const addErrorCell = (index, field) => {
		setErrorCells((prev) => {
			const exists = prev.some((cell) => cell.index === index && cell.field === field);
			if (!exists) {
				return [...prev, { index, field }];
			}
			return prev;
		});
	};

	const removeErrorCell = (index, field) => {
		setErrorCells((prev) => prev.filter((cell) => !(cell.index === index && cell.field === field)));
	};

	const handleChangeDefault = (index, value, field) => {
		const newRows = [...rows];
		let currentRowValue = newRows[index];

		if (field !== 'batch_no') {
			if (field === 'quantity' || field === 'free_quantity') {
				value = value?.replace(/[^0-9.]/g, '');
			} else {
				value = value?.replace(/[^0-9.]/g, '');
				const decimalCount = (value.match(/\./g) || []).length;
				if (decimalCount > 1) {
					value = +value?.slice(0, value.lastIndexOf('.'));
				}
			}
		}

		if (field === 'free_quantity') {
			if (Number(value) > 0 && Number(currentRowValue?.quantity) < Number(value)) {
				addErrorCell(index, field);
			} else {
				removeErrorCell(index, field);
			}
		}

		if (field === 'mrp') {
			const mrp = Number(value);
			const purchaseRate = Number(currentRowValue?.purchase_rate);

			if (mrp === 0) {
				addErrorCell(index, 'mrp');
			} else {
				removeErrorCell(index, 'mrp');
			}
			if (purchaseRate > 0 && purchaseRate > mrp) {
				addErrorCell(index, 'purchase_rate');
			} else {
				removeErrorCell(index, 'mrp');
				removeErrorCell(index, 'purchase_rate');
			}
		}

		// if (field === 'quantity') {
		// 	if (value === '' || value === null) {
		// 		addErrorCell(index, field);
		// 	} else {
		// 		removeErrorCell(index, field);
		// 	}
		// 	if (Number(currentRowValue.free_quantity) < Number(value)) {
		// 		removeErrorCell(index, 'free_quantity');
		// 	}
		// }

		if (field === 'purchase_rate') {
			const purchaseRate = Number(value);
			const mrp = Number(currentRowValue?.mrp);

			if (value !== '' && value !== null && (isNaN(purchaseRate) || purchaseRate < 0 || (mrp > 0 && purchaseRate > mrp))) {
				addErrorCell(index, 'purchase_rate');
			} else {
				removeErrorCell(index, 'purchase_rate');
				removeErrorCell(index, 'mrp');
			}
		}

		if (field === 'sale_rate') {
			const purchaseRate = Number(currentRowValue?.purchase_rate);
			const mrp = Number(currentRowValue?.mrp);
			const saleRate = Number(value);
			// if (value === null || value === '') {
			// 	addErrorCell(index, field);
			// } else
			if (saleRate > 0 && (saleRate < purchaseRate || saleRate > mrp)) {
				addErrorCell(index, field);
			} else {
				removeErrorCell(index, field);
			}
		}

		// if (field === 'trade_rate') {
		// 	if (Number(value) > 0 || value === '') {
		// 		addErrorCell(index, field);
		// 	} else {
		// 		removeErrorCell(index, field);
		// 	}
		// }

		newRows[index][field] = value;

		if (field === 'batch_no') {
			let error = [...errorCells.filter((er) => er.field !== 'batch_no')];
			const batchCount = {};
			newRows.forEach((row, i) => {
				if (!row.batch_no) {
					error.push({ index: i, field: 'batch_no' });
				}

				if (row.batch_no) {
					batchCount[row.batch_no] = (batchCount[row.batch_no] || 0) + 1;
				}
			});

			newRows.forEach((row, i) => {
				if (row.batch_no && batchCount[row.batch_no] > 1) {
					error.push({
						index: i,
						field: 'batch_no',
						customErrorMessage: {
							batch_no: 'This batch number already exists in the product table.',
						},
					});
				}
			});
			setErrorCells(error);
		}
		setRows(newRows);
		if (onChange) {
			onChange(newRows);
		}
	};

	const handleKeyDown = (index, event) => {
		let { name, value } = event.target;
		if (name === 'mfg_date' || name === 'expiry_date') {
			handleDateChange(index, value, name);
		} else {
			handleChangeDefault(index, value, name);
		}

		if (event.key === 'Enter') {
			const column = columns.find((col) => col.name === name);
			if (column && column.label === newRowgenerate) {
				addRow();
			}
		}
	};

	const getToolTipData = (name) => {
		switch (name) {
			case 'batch_no':
				return 'Batch No can not be empty.';
			// case 'quantity':
			// 	return 'Quantity can not be empty or 0';
			case 'mfg_date':
				return `MFG date can not be greater than ${Thismonth}/${ThisYear}`;
			case 'mrp':
				return 'MRP can not be empty';
			case 'purchase_rate':
				return 'Purchase Rate can not be greater than MRP or be empty';
			case 'free_quantity':
				return 'Free Quantity can not be more than Quantity';
			case 'expiry_date':
				return 'EXP Date can not be less than MFG date';
			default:
				return '';
		}
	};

	const ErrorModalOpen = () => {
		setShowError(true);
	};
	const CloseErrorModal = () => {
		setShowError(false);
		setTimeout(() => {
			if (rows.length > 0) {
				inputRefs.current[rows.length - 1]?.[0]?.focus();
			}
		}, 0);
	};
	return (
		<>
			{errorCells && errorCells?.length > 0 && (
				<div className="d-flex justify-content-end  text-danger  mb-0">
					{' '}
					<span
						style={{ textDecoration: 'underline', cursor: 'pointer' }}
						onClick={ErrorModalOpen}
					>
						Show all error
					</span>
				</div>
			)}
			<div className="text-center mb-2 custum_table">
				<div className=" custom-scroll">
					<table className="purchase-table">
						<thead>
							<tr>
								{columns.map((col) => (
									<th
										className={`${className}`}
										key={col.name}
										style={{
											width:
												col.label === 'Qty' || col.label === 'Free Qty' || col.label === 'MRP'
													? '7%'
													: col.label === 'Purchase Rate' || col.label === 'Sale Rate'
														? '13%'
														: '10%',
										}}
									>
										<div
											style={{
												display: 'flex',
												justifyItems: 'start',
												alignItems: 'center',
											}}
										>
											<span>{col.label}</span>
											<span style={{ color: 'red' }}>
												{[
													'batch_no',
													// 'quantity',
													'mrp',
												].includes(col.name)
													? '*'
													: ''}
											</span>
											{[
												'batch_no',
												// 'quantity',
												'mfg_date',
												'expiry_date',
												'mrp',
												'purchase_rate',
												'free_quantity',
											].includes(col.name) ? (
												<i className="toolTip_custum fa fa-info-circle">
													<span className="toolTip_custumtext">{getToolTipData(col.name)}</span>
												</i>
											) : (
												''
											)}
										</div>
									</th>
								))}
								{Tabletype === 'Product' && (
									<th className="batch-table-status-th">Status</th>
								)}
								<th className="batch-table-actions-th">Actions</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row, index) => {
								const isCellDisabled = (colName) =>
									disabled ||
									(Tabletype === 'Product' &&
										row.product_batch_id &&
										row.is_active === false &&
										colName !== 'quantity' &&
										colName !== 'free_quantity');
								return (
									<tr key={index} className={row.is_active === false ? 'batch-row-disabled' : ''}>
										{columns.map((col, colIndex) => (
											<td
												key={col.name}
												className={
													errorCells.some((cell) => cell.index === index && cell.field === col.name)
														? 'error'
														: ''
												}
											>
												{col.type === 'batch_no' ? (
													<InputField
														type="text"
														name={col.name}
														value={row[col.name]}
														error={errorCells.some(
															(cell) => cell.index === index && cell.field === col.name,
														)}
														onChange={(value) => handleChangeDefault(index, value, col.name)}
														onKeyDown={(e) => handleKeyDown(index, e)}
														disabled={isCellDisabled(col.name)}
														// className="table_input"
														ref={(el) => {
															if (!inputRefs.current[index]) {
																inputRefs.current[index] = [];
															}
															inputRefs.current[index][colIndex] = el;
														}}
													/>
												) : col.type === 'date' ? (
													<InputField
														type="text"
														name={col.name}
														value={row[col.name]}
														onChange={(value) => handleDateChange(index, value, col.name)}
														onKeyDown={(e) => handleKeyDown(index, e)}
														error={errorCells.some(
															(cell) => cell.index === index && cell.field === col.name,
														)}
														placeholder="MM/YY"
														maxLength="5"
														disabled={isCellDisabled(col.name)}
														// className="table_input"
														ref={(el) => {
															if (!inputRefs.current[index]) {
																inputRefs.current[index] = [];
															}
															inputRefs.current[index][colIndex] = el;
														}}
													/>
												) : (
													<InputField
														type="text"
														name={col.name}
														value={row[col.name]}
														onChange={(value) => handleChangeDefault(index, value, col.name)}
														onKeyDown={(e) => handleKeyDown(index, e)}
														error={errorCells.some(
															(cell) => cell.index === index && cell.field === col.name,
														)}
														disabled={isCellDisabled(col.name)}
														ref={(el) => {
															if (!inputRefs.current[index]) {
																inputRefs.current[index] = [];
															}
															inputRefs.current[index][colIndex] = el;
														}}
													/>
												)}
											</td>
										))}
										{/* <td>
										{!disabled && (
											<button
												className="delete mt-0 mb-0 bg-transparent"
												onClick={() => deleteLastRow(index, row.product_batch_id)}
												tabIndex="-1"
											>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
												>
													<path
														d="M3 6H5H21"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M10 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M14 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											</button>
										)}
									</td> */}

										{/* Status Cell (Only for Product) */}
										{Tabletype === 'Product' && (
											<td className="batch-table-status-td">
												{row.product_batch_id ? (
													(() => {
														const status = getBatchStatus(row);
														return (
															<span className={`batch-table-status-text status-${status.statusType}`}>
																{status.label}
															</span>
														);
													})()
												) : (
													<span className="batch-table-status-text status-new">
														{/* New */}
													</span>
												)}
											</td>
										)}

										{/* Actions Cell */}
										<td className="batch-table-actions-td">
											<div className="batch-table-actions-wrapper">
												{/* Status Toggle Icon (Only for existing batches in Product) */}
												{Tabletype === 'Product' && row.product_batch_id && (
													(() => {
														const status = getBatchStatus(row);
														const isActive = !status.isDeactivated;
														const canToggle = status.canToggle;

														return (
															<button
																type="button"
																className={`batch-table-toggle-btn ${isActive ? 'active' : 'inactive'} ${!canToggle ? 'disabled' : ''}`}
																onClick={() => canToggle && handleToggleClick(row, index, status)}
																disabled={!canToggle}
																title={isActive ? 'Click to Disable Batch' : 'Click to Reactivate Batch'}
																aria-label={isActive ? 'Disable batch' : 'Reactivate batch'}
															>
																{isActive ? <BsToggleOn size={26} /> : <BsToggleOff size={26} />}
															</button>
														);
													})()
												)}

												{/* Existing Delete Button */}
												{!disabled && (
													<button
														className="batch-table-delete-btn"
														onClick={() => deleteLastRow(index, row.product_batch_id)}
														tabIndex="-1"
														title="Delete Batch"
														type="button"
														aria-label="Delete batch"
													>
														<RiDeleteBinLine size={18} />
													</button>
												)}
											</div>
										</td>

									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
				{!disabled && (
					<button
						className="bg-transparent text-dark add-new-row-button mt-2 pb-5"
						onClick={addRow}
					>
						Add New Row
						<i
							className="fa fa-plus"
							style={{
								marginLeft: '.5rem',
								strokeWidth: '.1rem',
								color: 'var(--brand-color)',
								WebkitTextStrokeColor: '#fff',
								WebkitTextStrokeWidth: '1px',
							}}
						/>
					</button>
				)}
			</div>
			<div className="text-start">
				{showError && (
					<ErrorModal
						show={showError}
						isOpen={showError}
						onClose={CloseErrorModal}
						title="Error in Add product Table"
						error={errorCells}
					/>
				)}
			</div>

			{/* Batch Confirmation Modal Component */}
			<BatchConfirmModal
				isOpen={confirmModal.isOpen}
				onClose={() => setConfirmModal((prev) => ({ ...prev, isOpen: false }))}
				onConfirm={handleConfirmModal}
				actionType={confirmModal.actionType}
				productName={productName}
				batchNo={confirmModal.batchNo}
				statusLabel={confirmModal.statusLabel}
				statusColor={confirmModal.statusColor}
				reason={confirmModal.reason}
				onReasonChange={(reason) => setConfirmModal((prev) => ({ ...prev, reason }))}
				customReason={confirmModal.customReason}
				onCustomReasonChange={(customReason) => setConfirmModal((prev) => ({ ...prev, customReason }))}
				loader={confirmModal.loader}
			/>

		</>
	);
};

InputTable.propTypes = {
	initialRows: PropTypes.arrayOf(PropTypes.object),
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			type: PropTypes.string.isRequired,
		}),
	).isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.arrayOf(PropTypes.object).isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	newRowgenerate: PropTypes.string,
	Tabletype: PropTypes.string,
	productName: PropTypes.string,
};

export default InputTable;
